type EventType = {
  destroy: () => void;
};

export function resetField(
  el: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | HTMLElement
): EventType | void {
  // Narrowing down the element type to those that have a `form` property
  const formAssociatedElement = el as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

  // Check if the element has the form property
  const form: HTMLFormElement | null = formAssociatedElement.form;
  if (!form) {
    return;
  }

  const handleReset = () => {
    setTimeout(() => {
      if (el instanceof HTMLSelectElement) {
        el.dispatchEvent(new Event('change'));
        el.dispatchEvent(new CustomEvent('reset'));
      } else if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
        el.dispatchEvent(new Event('input'));
      } else {
        // Handle custom form elements or other cases
        el.dispatchEvent(new Event('reset'));
      }
    }, 0);
  };

  form.addEventListener('reset', handleReset);
  // eslint-disable-next-line consistent-return
  return {
    destroy() {
      form.removeEventListener('reset', handleReset);
    },
  };
}
